import { Component, OnInit,ViewChild,ElementRef,HostListener } from '@angular/core';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import { SessionsService } from '../common/services/sessions.service';
import { Router } from '@angular/router';
import {ConstantsService} from '../common/services/constants.service';
import * as $ from 'jquery';
declare var show_okshan_alert: Function;

@Component({
  selector: 'app-my-cars',
  templateUrl: './my-cars.component.html',
  styleUrls: ['./my-cars.component.css']
})
export class MyCarsComponent implements OnInit {

  sessionId:number=0;
  myCarList:any=[]; 
  favCarList:any=[];
  makeOfferList; 
  buyNowList;  
  fileUrl;
  webUrl;
  liveOkshanUrl:string="";
  getListRequestInprocess:boolean=false;
  private isNearBottom:boolean = true;
  private scrollContainer: any;
  private selectedTab:string="";  
  private listTotalCount:number=0;
  private listCurrentCount:number=0;

  @ViewChild('carType') carType:ElementRef 
  constructor(private httpserviceService:HttpserviceService,private sessionsService:SessionsService,private router:Router,private _constant: ConstantsService) { }

  ngOnInit(): void { 
      if(this.sessionsService.getSession("login_status")==null)
    {       
         window.location.href="#/visitor";       
    }
    else if(!this.sessionsService.getSession("login_status"))
       {
         window.location.href="#/visitor";
       }
    window.scrollTo(0, 0);
    this.sessionId=this.sessionsService.getSession("id");
    this.fileUrl=this._constant.uploadFileUrl;
    this.webUrl=this._constant.webUrl;
    setTimeout(() => {      
     this.getMyCarList(); 
    }, 300);    
  }

  /** getMyCarList function used to get my car list  */
  getMyCarList()
  {
    this.selectedTab="uploaded_cars";
    this.myCarList=[];   
    this.listTotalCount=0;
    this.listCurrentCount=0;
    this.myCarsListCount();
    let type=this.carType.nativeElement.value;
    this.getListRequestInprocess=true;
    let result =this.httpserviceService.myCarListRequest(type+'','0').
     pipe(retry(0)).
     subscribe((data)=>this.myCarListResponse(data),
     err => {
       this.getListRequestInprocess=false;
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** carListResponse function used to handle response */
  myCarListResponse(response)
  {
    console.log('carListResponse '+ response);
    this.getListRequestInprocess=false;
    if(response.status==="success")  
     {  
       let list=response.list;   
       list.forEach((element)=>{
       this.myCarList.push(element);   
       }) 
       this.listCurrentCount=this.myCarList.length;         
     }
     else
     {
     show_okshan_alert(response.reason);
     } 
  }

  /** carDetail function used to get car detail */
  carDetail(id)
  {
    let type=this.carType.nativeElement.value;
    if(type==1)
    {
    this.router.navigate(['fixed-price-car-detail'], { queryParams: { id: id } });
    }
    else if(type==2)
    {
    this.router.navigate(['auction-car-detail'], { queryParams: { id: id } });
    }
  }

  /** carDetail function used to open car detail */
  carDetail2(id,type)
  {
    if(type==1)
    {
    this.router.navigate(['fixed-price-car-detail'], { queryParams: { id: id } });
    }
    else if(type==2)
    {
    this.router.navigate(['auction-car-detail'], { queryParams: { id: id } });
    }
  }

  /** getModelFromId function used to get model from id  */
   getModelFromId(id)
   {
     if(this.sessionsService.getSession('all_model_list')==null)
     {
       return "";
     }
     let List=this.sessionsService.getSession('all_model_list');     
     if(List.length==0)
     {
       return "";
     } 
     return List[id];
   }

   /** getVariantFromId function used to get variant from id  */
   getVariantFromId(id)
   {     
     if(this.sessionsService.getSession('all_variant_list')==null)
     {
       return "";
     }
     let List=this.sessionsService.getSession('all_variant_list');         
     if(List.length==0)
     {
       return "";
     } 
     return List[id];
   }

  /** carDetail function used to open car detail */
  getViewAcceptOfferCarsList(id,type)
  {
    this.router.navigate(['fixed-price-car-seller-acceptance-detail'], { queryParams: { id: id } });
  }

   /** getFavoriteCarsList function used to get my favorite cars list  */
  getFavoriteCarsList(type)
  {
    this.favCarList=[];
    this.selectedTab="shortlisted_cars";
    this.listTotalCount=0;
    this.listCurrentCount=0;
    this.myFavCarsListCount(type);
    //let type=this.carType.nativeElement.value;
    this.getListRequestInprocess=true;
    let result =this.httpserviceService.getFavoriteCarsListRequest(type+'','0').
     pipe(retry(0)).
     subscribe((data)=>this.getFavoriteCarsListResponse(data),
     err => {
       this.getListRequestInprocess=false;
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** getFavoriteCarsListResponse function used to handle response */
  getFavoriteCarsListResponse(response)
  {
    console.log('carListResponse '+ response);
    this.getListRequestInprocess=false;
    if(response.status==="success")  
     {       
       let list=response.list;   
       list.forEach((element)=>{
       this.favCarList.push(element);   
       }) 
       this.listCurrentCount=this.favCarList.length;         
     }
     else
     {
     show_okshan_alert(response.reason);
     } 
  }

  /** getMoreMyCarList function used to get more my car list  */
  getMoreMyCarList()
  {
    let type=this.carType.nativeElement.value;
    this.getListRequestInprocess=true;
    let result =this.httpserviceService.myCarListRequest(type+'',this.listCurrentCount+'').
     pipe(retry(0)).
     subscribe((data)=>this.myCarListResponse(data),
     err => {
       this.getListRequestInprocess=false;
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** getMoreFavoriteCarsList function used to get my favorite cars list  */
  getMoreFavoriteCarsList()
  {
    this.selectedTab="shortlisted_cars";
    this.listTotalCount=0;
    this.listCurrentCount=0;
    let type=this.carType.nativeElement.value;
    this.getListRequestInprocess=true;
    let result =this.httpserviceService.getFavoriteCarsListRequest(type+'',this.listCurrentCount+'').
     pipe(retry(0)).
     subscribe((data)=>this.getFavoriteCarsListResponse(data),
     err => {
       this.getListRequestInprocess=false;
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** getFavoriteCarsList function used to get my cars list count */
  myCarsListCount()
  {
    let type=this.carType.nativeElement.value;
    this.getListRequestInprocess=true;
    let result =this.httpserviceService.myCarsListCountRequest(type+'').
     pipe(retry(0)).
     subscribe((data)=>this.myCarsListCountResponse(data),
     err => {
       this.getListRequestInprocess=false;
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** myCarsListCountResponse function used to handle response */
  myCarsListCountResponse(response)
  {
    console.log('myCarsListCountResponse '+ response);
    if(response.status==="success")  
     {       
      this.listTotalCount=response.count;         
     }
     else
     {
     show_okshan_alert(response.reason);
     } 
  }

  /** myFavCarsListCount function used to get my favorite cars list count  */
  myFavCarsListCount(type)
  {
    //let type=this.carType.nativeElement.value;
    this.getListRequestInprocess=true;
    let result =this.httpserviceService.myFavCarsListCountRequest(type+'').
     pipe(retry(0)).
     subscribe((data)=>this.myFavCarsListCountResponse(data),
     err => {
       this.getListRequestInprocess=false;
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** myFavCarsListCountResponse function used to handle response */
  myFavCarsListCountResponse(response)
  {
    console.log('myFavCarsListCountResponse '+ response);
    if(response.status==="success")  
     {       
      this.listTotalCount=response.count;         
     }
     else
     {
     show_okshan_alert(response.reason);
     } 
  }

  /** onChangeType function used to refresh detail on type change*/
  onChangeType()
  {
    if(this.selectedTab==="uploaded_cars")
       {
        this.getMyCarList();
       }
       else if(this.selectedTab==="shortlisted_cars")
       {
        this.getFavoriteCarsList(1);
       }
  }

  /** grenerateLiveOkshanLink function used to generate live okshan link */
  grenerateLiveOkshanLink(id)
  {
  let detail={"id":id};  
  this.liveOkshanUrl=this.webUrl+"live-okshan-link?qzwxy="+btoa(JSON.stringify(detail))
  }

  @HostListener('window:scroll', ['$event'])
  scrolled(event: any): void {
    this.isNearBottom = this.isUserNearBottom();
    if(this.isNearBottom)
    {
     if(!this.getListRequestInprocess)
     { 
       if(this.selectedTab==="uploaded_cars")
       {
        if(this.listCurrentCount<this.listTotalCount)
        {  
        this.getMoreMyCarList()
        }
       }
       else if(this.selectedTab==="shortlisted_cars")
       {
       if(this.listCurrentCount<this.listTotalCount)
        {  
        this.getMoreFavoriteCarsList()
        }
       }
     }
    }
  }

private scrollToBottom(): void {
    window.scroll({
      top: this.scrollContainer.scrollHeight,
      left: 0,
      behavior: 'smooth'
    });
  }

  private isUserNearBottom(): boolean {
    const threshold = 300;
    const position = window.scrollY + window.innerHeight;
    const height = document.body.scrollHeight;
    return position > height - threshold;
  }

  showOffer(id){
	  this.router.navigate(['show-offers'], { queryParams: { id: id } })
  } 
      
  getMakeOfferList()
  {
     this.httpserviceService.myAppCarListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.myAppCarListResponse(data),
     err => {
       alert('Something went wrong');
       console.log('Something went wrong', err);
       //this.isLoading=true;
    })     
  }

 
  myAppCarListResponse(response)
  {
    console.log('myAppCarListResponse '+ response.status);
    if(response.status==="success")  
     {
       this.makeOfferList=response.make_offer;
	   //console.log(response.list);
     }
     else
     {
     alert(response.reason);
     //this.isLoading=true;
     } 
  }
      
  getBuyNowList()
  {
     this.httpserviceService.myAppCarListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.myApp1CarListResponse(data),
     err => {
       alert('Something went wrong');
       console.log('Something went wrong', err);
       //this.isLoading=true;
    })     
  }

 
  myApp1CarListResponse(response)
  {
    console.log('myAppCarListResponse '+ response.status);
    if(response.status==="success")  
     {
       this.buyNowList=response.buy_now;
	   //console.log(response.list);
     }
     else
     {
     alert(response.reason);
     //this.isLoading=true;
     } 
  }
}
